import axios from 'axios'

export const GET_LICENSE_SUCCESS = 'GET_LICENSE_SUCCESS';

export function getLicenseSuccess(license) {
    return {
        type: GET_LICENSE_SUCCESS,
        license
    };
}


async function getData() {
    const res = await axios("/license");
    return res.data;
  }

export function fetchLicense() {
    return (dispatch) => {
        getData()
        .then(response => {
            dispatch(getLicenseSuccess(response));
        })
        .catch(err => 
        {

        })
        }
    }